import { Component, OnInit, Input } from '@angular/core';
import { TagLabelColors } from '../../interfaces';
import { VIDEO_TAG_LABELS } from '../../enums';

@Component({
  selector: 'app-filter-tags-label',
  templateUrl: './filter-tags-label.component.html',
  styleUrls: ['./filter-tags-label.component.scss']
})
export class FilterTagsLabelComponent implements OnInit {
  @Input() label: TagLabelColors | null = null;
  @Input() isActive: boolean = false;
  //@Input() shouldCropLabel: boolean = false;

  //croppedLength: number = 5;

  private readonly labelColors: string[] = ['color-pink', 'color-red', 'color-green', 'color-purple', 'color-blue', 'color-orange'];

  private readonly labelColorMap: Record<string, string> = {
    [VIDEO_TAG_LABELS.ALL]: 'color-pink',
    [VIDEO_TAG_LABELS.NEW]: 'color-red'
  };

  constructor() {}

  ngOnInit(): void {}

  getRandomLabelClass(label: string): string {
    if (!label) return '';
    const hash = this.generateHash(label);
    const colorIndex = hash % this.labelColors.length;
    return this.labelColors[colorIndex];
  }

  getLabelClass(): string {
    if (!this.label) return '';
    return this.labelColorMap[this.label.id ?? ''] || this.getRandomLabelClass(this.label.name);
  }

  private generateHash(input: string): number {
    let hash = 0;
    for (let i = 0; i < input.length; i++) {
      hash = (hash * 31 + input.charCodeAt(i)) % 100000;
    }
    return hash;
  }
}
